import { createActionCreator } from "common/ReduxUtils";
import { StorageSelectShippingActionTypes } from "../StorageSelectShippingActionTypes";

export const setCarrierType = createActionCreator<string>(
  StorageSelectShippingActionTypes.STORAGE_SET_CARRIER_TYPE,
  "carrierType"
);
